import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import UserForm from '@app/components/apps/Users/UserForm';
import { useLocation } from 'react-router-dom';

export const EditUserPage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit User');

  const { t } = useTranslation();

  const routes = [
    {
      path: '/users',
      breadcrumbName: 'Users',
    },
    {
      path: '/edit-user',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <UserForm
          type={'edit'}
          editable={true}
          id={id}
          pageTitle={`Edit User`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default EditUserPage;
